export default "__VITE_ASSET__56c2735b__"